import react from "react";
import React from "react";
import {Link} from "react-router-dom";
import styles from "./SeanceList.module.css";
import TitleSecondary from "../../Title/TitleSecondary";
import { ReactComponent as AjouterIcone } from "../../../icons/ajouter.svg";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";

const SeanceList = ({ seances, title = "Séances" }) => {
    return (
        <div className={styles.seancesListContainer}>
            <TitleSecondary text={title} />
            <ul>
                {seances?.map((seance, index) => (
                    (index < 9) ? (
                        <li key={index} style={{ display: "flex" }}>
                            <span className={styles.seanceDate}>{DateService.formatDate(seance.startDate)}</span>
                            <Link className={styles.seanceTitre} to={`/admin/seances/${seance.id}`}>{seance.titre}</Link>
                            <Link className={styles.seanceEntreprise} to={`/admin/entreprises/${seance.entreprise.id}`}>
                                {seance.entreprise.nom}
                            </Link>
                        </li>) : null
                ))}
                <div className={styles.voirPlus}>
                    <Link to={Routing.routes.adminSeancesDirect}>
                        <AjouterIcone />
                        Voir plus
                    </Link>
                </div>
            </ul>
        </div>
    );
}

export default SeanceList;